<p-toolbar>
    <div class="p-toolbar-group-start">
        <p-button icon="pi pi-align-justify" (click)="sidebarVisible = true" styleClass="p-button-rounded p-button-info p-button-text p-button-lg"></p-button>
        <p>Olá, {{ usuario?.nome ?? '' }} - {{ usuario?.empresa ?? '' }}</p>
    </div>

    <div class="p-toolbar-group-end">
        <p-button icon="pi pi-user" (click)="menu.toggle($event)" styleClass="p-button-rounded p-button-info p-button-text p-button-lg"></p-button>
        <p-menu #menu [model]="menusUser" styleClass="menu-user" [popup]="true" [style]="{ width: 'auto', 'font-size': '2rem' }"></p-menu>
    </div>
</p-toolbar>

<p-sidebar [(visible)]="sidebarVisible" [ngClass]="'menu'">
    <ng-template pTemplate="header">
        <app-logo [paramChave]="true" [loadingEmpresa]="false" [width]="'100%'" type="logo-text"></app-logo>
    </ng-template>

    <ng-template pTemplate="content">
        <p-panelMenu [model]="menus" [style]="{'background-color':'#f47d35'}" [multiple]="false"></p-panelMenu>
    </ng-template>

    <ng-template pTemplate="footer">
        <span class="versao text-sm">{{version}}</span>
    </ng-template>
</p-sidebar>

<div id="home-content" #homecontent class="home-container">
    <app-authentication-invalid-dialog></app-authentication-invalid-dialog>
    <router-outlet></router-outlet>
</div>